import {Button, message, Modal, QRCode, Tooltip} from "antd";
import {CopyOutlined} from "@ant-design/icons";
import {useRecoilValue} from "recoil";
import {globalReferralSettingState, globalUserDetailState,} from "../../../../_common/global_state";
import {useTranslation} from "react-i18next";
import copy from "copy-to-clipboard";

const QrCard = ({title, url, onCopy}) => (
    <div className="qrModal-card">
        <span className="qrModal-card-label">{title}</span>
        <div className="qrModal-qr-wrap">
            <QRCode value={url} size={148} bordered={false}/>
        </div>
        <div className="qrModal-url-row">
            <Tooltip title={url} placement="top" mouseEnterDelay={0.5}>
                <span className="qrModal-url">{url}</span>
            </Tooltip>
            <Button
                type="text"
                size="small"
                icon={<CopyOutlined/>}
                className="qrModal-copy-btn"
                onClick={() => onCopy(url)}
            />
        </div>
    </div>
);

const QrModal = (props) => {
    const {isModalOpen, handleCancel} = props;
    const {t} = useTranslation();

    const userDetails = useRecoilValue(globalUserDetailState);
    const qrReferral = useRecoilValue(globalReferralSettingState);

    const mainDomain = window.location.hostname.split(".").slice(-2).join(".");

    const homePageUrl = "https://" + mainDomain + "/?affiliate=" + userDetails?.affiliateCode;
    const liveUrl = "https://member." + mainDomain + "/#/register?type=individual&affiliate=" + userDetails?.affiliateCode;
    const demoUrl = "https://member." + mainDomain + "/#/register?type=demo&affiliate=" + userDetails?.affiliateCode;

    const copyLink = (link) => {
        copy(link);
        message.success(t("user.successMsg.affiliateLinkCopiedToClipboard"));
    };

    return (
        <Modal
            title={t("referral.modal.title")}
            open={isModalOpen}
            footer={null}
            onCancel={handleCancel}
            className={"l-1 modalQr qrModal-l3"}
            getContainer={() => document.getElementById("layout-3")}
            width={640}
            centered
        >
            <div className="qrModal-cards">
                {qrReferral?.referralLink && (
                    <QrCard
                        title={t("referral.homepage")}
                        url={homePageUrl}
                        onCopy={copyLink}
                    />
                )}
                {qrReferral?.liveReferralLink && (
                    <QrCard
                        title={t("referral.live")}
                        url={liveUrl}
                        onCopy={copyLink}
                    />
                )}
                {qrReferral?.demoReferralLink && (
                    <QrCard
                        title={t("referral.demo")}
                        url={demoUrl}
                        onCopy={copyLink}
                    />
                )}
            </div>
        </Modal>
    );
};

export default QrModal;
